import { uuid } from '@/lib'
import * as action from '../action-types'
import * as mutation from '../mutation-types'

export const state = {
  windows: []
}

export const getters = {
  windows: state => () =>
    state.windows,

  window: state => windowId =>
    state.windows.find(w => w.windowId === windowId),

  windowByContentId: state => contentId =>
    state.windows.find(w => w.data.contentId === contentId),

  windowTitle: state => windowId =>
    state.windows.find(w => w.windowId === windowId).title,

  windowData: state => windowId => {
    const window = state.windows.find(w => w.windowId === windowId)
    return window && window.data ? window.data : {}
  },

  zIndex: state => windowId => {
    const zIndex = state.windows.reduce((res, window) => {
      return Math.max(res, window.data.zIndex || 0)
    }, 0)
    const window = windowId ? state.windows.find(w => w.windowId === windowId) : null
    if (window && window.data.zIndex === zIndex) return zIndex
    return zIndex + 1
  }
}

function numberWindowTitle (getters, title) {
  let window = getters.windows().find(p => p.title === title)
  if (!window) return title
  let result = ''
  let number = 2
  while (window) {
    result = `${title} (${number++})`
    window = getters.windows().find(p => p.title === result)
  }
  return result
}

export const actions = {
  [action.WINDOW_CREATE] ({commit, getters}, {componentType, title, data}) {
    const zIndex = getters.zIndex()
    data = Object.assign({}, {zIndex}, data)
    title = numberWindowTitle(getters, title)
    commit(mutation.WINDOW_CREATE, {
      windowId: uuid(),
      componentType,
      title,
      data,
      emit: true
    })
  },

  [action.WINDOW_OPEN] ({commit, getters}, {windowId, componentType, title}) {
    const zIndex = getters.zIndex(windowId)
    commit(mutation.WINDOW_OPEN, {windowId, componentType, title, zIndex, emit: true})
  },

  [action.WINDOW_OPEN_CREATE] ({dispatch, getters}, {contentId, componentType, title}) {
    const window = getters.windowByContentId(contentId)
    if (!window) {
      dispatch(action.WINDOW_CREATE, {componentType, title, data: {contentId}})
    } else {
      dispatch(action.WINDOW_OPEN, {windowId: window.windowId, componentType, title})
    }
  },

  [action.WINDOW_ACTIVATE] ({commit, getters}, {windowId}) {
    const zIndex = getters.zIndex(windowId)
    commit(mutation.WINDOW_OPEN, {windowId, zIndex, emit: true})
  },

  [action.WINDOW_CLOSE] ({commit}, {windowId}) {
    commit(mutation.WINDOW_DELETE, {windowId, emit: true})
  },

  [action.WINDOW_DATA] ({commit}, {windowId, data}) {
    commit(mutation.WINDOW_DATA, {windowId, data, emit: true})
  }
}

export const mutations = {
  [mutation.WINDOW_STATE] (state, windows) {
    windows = (Array.isArray(windows) ? windows : (typeof windows === 'object' ? [windows] : []))
    state.windows = windows.map(each => {
      each.data = each.data || {}
      return each
    })
  },

  [mutation.WINDOW_CREATE] (state, payload) {
    const window = {
      windowId: payload.windowId,
      componentType: payload.componentType,
      title: payload.title || payload.name || 'Unnamed Window',
      data: Object.assign({tabIndex: 0, zIndex: 0}, payload.data),
      visible: true
    }
    state.windows.push(window)
  },

  [mutation.WINDOW_DELETE] (state, {windowId}) {
    const idx = state.windows.findIndex(w => w.windowId === windowId)
    state.windows.splice(idx, 1)
  },

  [mutation.WINDOW_OPEN] (state, {windowId, componentType, title, zIndex}) {
    const window = state.windows.find(w => w.windowId === windowId)
    if (!window) return
    window.visible = true
    window.componentType = componentType || window.componentType
    window.title = title || window.title
    window.data.zIndex = zIndex
    // Computed properties don't fire on properties update on an object in an array
    // 09.12.2017: This seems to be a dangerous thing, because computed properties
    // that depend on window contentId (?) and template data fire
    // state.windows = Object.assign([], state.windows)
  },

  [mutation.WINDOW_CLOSE] (state, {windowId}) {
    const window = state.windows.find(w => w.windowId === windowId)
    if (!window) return
    window.visible = false
  },

  [mutation.WINDOW_TITLE] (state, {windowId, title}) {
    const window = state.windows.find(w => w.windowId === windowId)
    if (!window) return
    window.title = title
  },

  [mutation.WINDOW_DATA] (state, {windowId, data}) {
    const window = state.windows.find(w => w.windowId === windowId)
    if (!window) return
    // window.data = Object.assign({}, window.data, data)
    Object.assign(window.data, data)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/windows.js